import { graphql, HttpResponse } from 'msw'
import {
  EmploymentStatus,
  Occupation,
  PersonalNetWorthRange,
  type EnrollmentPersonalInfoData,
  type EnrollmentPersonalInfoSubmitOutput,
} from '../../../models'

export const getEnrollmentPersonalInfoDataMock: EnrollmentPersonalInfoData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/confirm-personal-info',
  enrollmentData: {
    userInfo: {
      employmentStatus: EmploymentStatus.EMPLOYED,
      occupation: Occupation.OTHER,
      netWorthRange: PersonalNetWorthRange.BETWEEN_100K_AND_200K,
    },
  },
}

export const submitEnrollmentPersonalInfoDataMock: EnrollmentPersonalInfoSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/personal-info',
}

export const mockGetEnrollmentPersonalInfoData = graphql.mutation('getEnrollmentPersonalInfoData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentPersonalInfoDataMock } })
})

export const mockSubmitEnrollmentPersonalInfoData = graphql.mutation('submitEnrollmentPersonalInfoData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentPersonalInfoDataMock } })
})

export const mockEnrollmentPersonalInfo = [mockGetEnrollmentPersonalInfoData, mockSubmitEnrollmentPersonalInfoData]
